import { render, staticRenderFns } from "./UpgradeAccount.vue?vue&type=template&id=a2cc52d4&scoped=true"
import script from "./UpgradeAccount.vue?vue&type=script&lang=js"
export * from "./UpgradeAccount.vue?vue&type=script&lang=js"
import style0 from "./UpgradeAccount.vue?vue&type=style&index=0&id=a2cc52d4&prod&lang=scss"
import style1 from "./UpgradeAccount.vue?vue&type=style&index=1&id=a2cc52d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cc52d4",
  null
  
)

export default component.exports